/*
 * @Name "路由path"与"在UEM中登记注册的页面编码" 对称表
 */
/* eslint-disable */
export default [
    {reg: /\/home/, pageCode: 'P90458DFE84263E', pageName: '爱上会起始页'},
    {reg: /\/exhi\?exhiId/, pageCode: 'P90EF6FA4585757', pageName: '资源首页'},
    {reg: /\/orderConfig\/recentOrders/, pageCode: 'P468B701EA81F69', pageName: '近期订单页'},
    {reg: /\/orderConfig\/commonInvoice/, pageCode: 'P468B701E4A4A89', pageName: '常用发票页'},
    {reg: /\/orderConfig\/commonAddress/, pageCode: 'P468B701DD58CA8', pageName: '常用地址页'},
    {reg: /\/orderConfig\/commonContacts/, pageCode: 'P468B701D6A4139', pageName: '常用联系人页'},
    {reg: /\/orderConfig\/myImportExport/, pageCode: 'P589711B839F04C', pageName: '我的导入导出'},
    {reg: /\/orderConfig\/personalInfo/, pageCode: 'P468B701CF61A2A', pageName: '个人信息页'},
    {reg: /\/config\/exhiConfig/, pageCode: 'P468B701A305ECF', pageName: '展会配置页'},
    {reg: /\/config\/exhiInfo/, pageCode: 'P468B701A932A4A', pageName: '展会基本信息页'},
    {reg: /\/config\/exhiDetail/, pageCode: 'P58973D4A436782', pageName: '展会配置-展会详情'},
    {reg: /\/config\/userPermissionConfig/, pageCode: 'P58977557168BF3', pageName: '用户权限列表'},
    {reg: /\/orderConfig\/applicationManagement/, pageCode: 'P72C57CB2871619', pageName: '我的待办'},
]
